/**
 * Bandeiras dos idiomas em SVG inline.
 *
 * O emoji de bandeira é formado por dois "regional indicators" (🇧🇷 = 🇧+🇷).
 * Linux/Chrome não traz glyph para essa combinação, então o navegador cai no
 * fallback e desenha as DUAS LETRAS do país — era por isso que os seletores de
 * idioma mostravam "BR", "US" e "ES" no lugar das bandeiras.
 */
import React from "react";

export const FlagBR = props => (
  <svg viewBox="0 0 28 20" {...props}>
    <rect width="28" height="20" rx="2" fill="#009b3a" />
    <path d="M14 2.6 25.2 10 14 17.4 2.8 10z" fill="#fedf00" />
    <circle cx="14" cy="10" r="4.2" fill="#002776" />
    <path
      d="M9.9 8.9a12 12 0 0 1 8.2 2.3 4.2 4.2 0 0 1-.2.8 11 11 0 0 0-7.8-2.3 4.2 4.2 0 0 1-.2-.8z"
      fill="#fff"
    />
  </svg>
);

export const FlagUS = props => (
  <svg viewBox="0 0 28 20" {...props}>
    <rect width="28" height="20" rx="2" fill="#fff" />
    <g fill="#b22234">
      <rect width="28" height="1.54" y="0" />
      <rect width="28" height="1.54" y="3.08" />
      <rect width="28" height="1.54" y="6.15" />
      <rect width="28" height="1.54" y="9.23" />
      <rect width="28" height="1.54" y="12.31" />
      <rect width="28" height="1.54" y="15.38" />
      <rect width="28" height="1.54" y="18.46" />
    </g>
    <rect width="12" height="10.77" fill="#3c3b6e" />
    <g fill="#fff">
      <circle cx="2.4" cy="2.2" r="0.7" />
      <circle cx="6" cy="2.2" r="0.7" />
      <circle cx="9.6" cy="2.2" r="0.7" />
      <circle cx="4.2" cy="4.4" r="0.7" />
      <circle cx="7.8" cy="4.4" r="0.7" />
      <circle cx="2.4" cy="6.6" r="0.7" />
      <circle cx="6" cy="6.6" r="0.7" />
      <circle cx="9.6" cy="6.6" r="0.7" />
      <circle cx="4.2" cy="8.8" r="0.7" />
      <circle cx="7.8" cy="8.8" r="0.7" />
    </g>
  </svg>
);

export const FlagES = props => (
  <svg viewBox="0 0 28 20" {...props}>
    <rect width="28" height="20" rx="2" fill="#aa151b" />
    <rect width="28" height="10" y="5" fill="#f1bf00" />
    <rect x="5" y="7.6" width="3.4" height="4.8" rx="0.5" fill="#aa151b" />
  </svg>
);

/** Idiomas suportados, na ordem em que aparecem nos seletores. */
export const LANGUAGES = [
  { code: "pt", Flag: FlagBR, label: "PT", name: "Português" },
  { code: "en", Flag: FlagUS, label: "EN", name: "English" },
  { code: "es", Flag: FlagES, label: "ES", name: "Español" }
];
